/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, {
  AxiosResponse,
  AxiosInstance,
  AxiosRequestConfig,
} from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError,
} from '../base';
import { RegisterDto } from '../models';
import { RegisterResponseDto } from '../models';
import { ResetPasswordWithTokenDto } from '../models';
/**
 * AuthPublicApi - axios parameter creator
 * @export
 */
export const AuthPublicApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @summary Registers a new user and generates authentication tokens
     * @param {RegisterDto} body The data needed to register a new user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authPublicControllerRegister: async (
      body: RegisterDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling authPublicControllerRegister.'
        );
      }
      const localVarPath = `/auth-public/register`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authPublicControllerRequestResetPassword: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth-public/password/reset-request`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {ResetPasswordWithTokenDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authPublicControllerResetPassword: async (
      body: ResetPasswordWithTokenDto,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      if (body === null || body === undefined) {
        throw new RequiredError(
          'body',
          'Required parameter body was null or undefined when calling authPublicControllerResetPassword.'
        );
      }
      const localVarPath = `/auth-public/password/reset-confirm`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      const needsSerialization =
        typeof body !== 'string' ||
        localVarRequestOptions.headers['Content-Type'] === 'application/json';
      localVarRequestOptions.data = needsSerialization
        ? JSON.stringify(body !== undefined ? body : {})
        : body || '';

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authPublicControllerValidateResetToken: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth-public/password/reset-validate`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    authPublicControllerVerifyEmail: async (
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/auth-public/verify-email`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, 'https://example.com');
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions: AxiosRequestConfig = {
        method: 'POST',
        ...baseOptions,
        ...options,
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      const query = new URLSearchParams(localVarUrlObj.search);
      for (const key in localVarQueryParameter) {
        query.set(key, localVarQueryParameter[key]);
      }
      for (const key in options.params) {
        query.set(key, options.params[key]);
      }
      localVarUrlObj.search = new URLSearchParams(query).toString();
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url:
          localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * AuthPublicApi - functional programming interface
 * @export
 */
export const AuthPublicApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Registers a new user and generates authentication tokens
     * @param {RegisterDto} body The data needed to register a new user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authPublicControllerRegister(
      body: RegisterDto,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => Promise<AxiosResponse<RegisterResponseDto>>
    > {
      const localVarAxiosArgs = await AuthPublicApiAxiosParamCreator(
        configuration
      ).authPublicControllerRegister(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authPublicControllerRequestResetPassword(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs =
        await AuthPublicApiAxiosParamCreator(
          configuration
        ).authPublicControllerRequestResetPassword(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {ResetPasswordWithTokenDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authPublicControllerResetPassword(
      body: ResetPasswordWithTokenDto,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs = await AuthPublicApiAxiosParamCreator(
        configuration
      ).authPublicControllerResetPassword(body, options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authPublicControllerValidateResetToken(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs =
        await AuthPublicApiAxiosParamCreator(
          configuration
        ).authPublicControllerValidateResetToken(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authPublicControllerVerifyEmail(
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<void>>
    > {
      const localVarAxiosArgs =
        await AuthPublicApiAxiosParamCreator(
          configuration
        ).authPublicControllerVerifyEmail(options);
      return (
        axios: AxiosInstance = globalAxios,
        basePath: string = BASE_PATH
      ) => {
        const axiosRequestArgs: AxiosRequestConfig = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * AuthPublicApi - factory interface
 * @export
 */
export const AuthPublicApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @summary Registers a new user and generates authentication tokens
     * @param {RegisterDto} body The data needed to register a new user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authPublicControllerRegister(
      body: RegisterDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<RegisterResponseDto>> {
      return AuthPublicApiFp(configuration)
        .authPublicControllerRegister(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authPublicControllerRequestResetPassword(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return AuthPublicApiFp(configuration)
        .authPublicControllerRequestResetPassword(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ResetPasswordWithTokenDto} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authPublicControllerResetPassword(
      body: ResetPasswordWithTokenDto,
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return AuthPublicApiFp(configuration)
        .authPublicControllerResetPassword(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authPublicControllerValidateResetToken(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return AuthPublicApiFp(configuration)
        .authPublicControllerValidateResetToken(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async authPublicControllerVerifyEmail(
      options?: AxiosRequestConfig
    ): Promise<AxiosResponse<void>> {
      return AuthPublicApiFp(configuration)
        .authPublicControllerVerifyEmail(options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * AuthPublicApi - object-oriented interface
 * @export
 * @class AuthPublicApi
 * @extends {BaseAPI}
 */
export class AuthPublicApi extends BaseAPI {
  /**
   *
   * @summary Registers a new user and generates authentication tokens
   * @param {RegisterDto} body The data needed to register a new user
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthPublicApi
   */
  public async authPublicControllerRegister(
    body: RegisterDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<RegisterResponseDto>> {
    return AuthPublicApiFp(this.configuration)
      .authPublicControllerRegister(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthPublicApi
   */
  public async authPublicControllerRequestResetPassword(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return AuthPublicApiFp(this.configuration)
      .authPublicControllerRequestResetPassword(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {ResetPasswordWithTokenDto} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthPublicApi
   */
  public async authPublicControllerResetPassword(
    body: ResetPasswordWithTokenDto,
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return AuthPublicApiFp(this.configuration)
      .authPublicControllerResetPassword(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthPublicApi
   */
  public async authPublicControllerValidateResetToken(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return AuthPublicApiFp(this.configuration)
      .authPublicControllerValidateResetToken(options)
      .then((request) => request(this.axios, this.basePath));
  }
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AuthPublicApi
   */
  public async authPublicControllerVerifyEmail(
    options?: AxiosRequestConfig
  ): Promise<AxiosResponse<void>> {
    return AuthPublicApiFp(this.configuration)
      .authPublicControllerVerifyEmail(options)
      .then((request) => request(this.axios, this.basePath));
  }
}
